import React from "react";
import { motion } from "framer-motion";
import { ShoppingCart, Utensils, ClipboardCheck, MessageSquare } from "lucide-react";

const steps = [
  {
    icon: <ShoppingCart className="w-8 h-8 text-yellow-500" />,
    step: "Paso 1",
    title: "Elige tus platos",
    description: "Puedes ver la carta del restaurante pulsando el icono de la parte superior izquierda y ver todos los productos, luego cada seccion despliega una lista de todos los platos disponibles, elige los que quieras y personalizalos a tu gusto, automaticamente se agregan al carrito que veras al final del proceso. ",
  },
  {
    icon: <Utensils className="w-8 h-8 text-yellow-500" />,
    step: "Paso 2",
    title: "Personaliza", 
    description: "Existe una seccion dentro del modal, en donde puedes exluir cualquier ingrediente que no desees. Agrega extras deslizando a la izquierda, para ver mas opciones. ",
  },
  {
    icon: <ClipboardCheck className="w-8 h-8 text-yellow-500" />,
    step: "Paso 3",
    title: "Tus datos",
    description: "Completa la información de entrega y revisa el resumen.",
  },
  {
    icon: <MessageSquare className="w-8 h-8 text-yellow-500" />,
    step: "Paso 4",
    title: "Envíar pedido a WhatsApp",
    description: "Tendras un resumen de todo tu pedido, en cual podras elegir tu medio de pago, finaliza enviando por WhatsApp y ¡Buen provecho!",
  },
];

const InstruccionesPasoAPaso = () => {
  return (
    <div className="w-full max-w-4xl mx-auto mb-12 px-4 relative z-10">
      <h2 className="text-center text-neutral-400 font-extrabold mb-8 text-2xl uppercase tracking-wider relative">
        ¿Como realizar tu pedido?
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {steps.map((step, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white/80 backdrop-blur-sm p-4 rounded-xl border border-yellow-100 shadow-lg flex flex-col items-center text-center"
          >
            <div className="mb-3 p-2 bg-yellow-50 rounded-full">
              {step.icon}
            </div>
            <span className="text-[10px] font-bold text-neutral-400 uppercase tracking-wider mb-0.5">
              {step.step}
            </span>
            <h3 className="font-bold text-yellow-600 mb-1 leading-tight text-sm">
              {step.title}
            </h3>
            <p className="text-[13px] text-neutral-600 leading-tight">
              {step.description}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default InstruccionesPasoAPaso;
